import {defineStore} from 'pinia';
import {ref, computed} from 'vue';
import {useApiClient} from "@/hooks/api-hook.ts";
import {Role} from "@/api/client/models/index.ts";

export const useCharterRoleStore = defineStore('charter-role', () => {
  const api = useApiClient()

  // State
  const roles = ref<Role[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  // Getters
  const rolesCount = computed(() => roles.value.length);
  const hasRoles = computed(() => roles.value.length > 0);
  const isLoading = computed(() => loading.value);
  const hasError = computed(() => error.value !== null);

  // Actions
  async function fetchRoles() {
    loading.value = true;
    error.value = null;

    try {
      roles.value = await api.charterRole.get()
    } catch (err) {
      error.value = err instanceof Error ? err.message : 'Failed to fetch roles';
      console.error('Error fetching roles:', err);
    } finally {
      loading.value = false;
    }
  }

  function clearRoles() {
    roles.value = [];
    error.value = null;
  }

  function clearError() {
    error.value = null;
  }

  return {
    // State
    roles,
    loading,
    error,

    // Getters
    rolesCount,
    hasRoles,
    isLoading,
    hasError,

    // Actions
    fetchRoles,
    clearRoles,
    clearError
  };
});
